<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="jor">
      <div class="jor-inner">
        <JournalType
          :data="journalTypes"
          v-loading="typeLoading"
          v-model="typeActiveIndex"
          @typeClick="typeClick"
        />
        <div class="jor-search">
          <SearchBar
            :num="totalItem"
            v-model="searchKey"
            @btnClick="searchBarClick"
          />
        </div>
        <div v-loading="listLoading" class="jor-lists">
          <JorItem
            v-for="(item, index) in journalList"
            :key="index"
            :data="item"
          />
        </div>
      </div>
      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>
    <FootBar class="footer" />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination/index";
import SearchBar from "@/components/SearchBar/index";
import { JOURNAL_TYPE } from "@/constant/dict";
import { jourList } from "@/api/journal";
import JorItem from "./components/jorItem.vue";
import JournalType from "./components/JournalType.vue";
export default {
  components: {
    Pagination,
    JorItem,
    JournalType,
    SearchBar,
  },
  data() {
    return {
      journalTypes: [],
      typeLoading: false,
      listLoading: false,
      typeActiveIndex: 0,
      journalList: [],
      page: {
        pageIndex: 1,
        pageSize: 6,
      },
      totalItem: 0,
      searchKey: "",
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    async getDict() {
      this.typeLoading = true;
      const data = await this.$store
        .dispatch("getDictData", JOURNAL_TYPE)
        .finally(() => {
          this.typeLoading = false;
        });
      this.journalTypes = data;
      this.getList();
    },

    async getList() {
      this.listLoading = true;
      this.journalList.length = 0;
      const { list, totalItem } = await this.$axios
        .post(jourList, {
          ...this.page,
          goodsCategory: this.journalTypes[this.typeActiveIndex].dictValue,
          goodsName: this.searchKey,
        })
        .finally(() => {
          this.listLoading = false;
        });
      this.journalList = list;
      this.totalItem = totalItem;
    },
    searchBarClick() {
      this.page.pageIndex = 1;
      this.getList();
    },
    typeClick() {
      this.page.pageIndex = 1;
      this.getList();
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.jor {
  background: #f5f5f5;
  padding-top: 20px;
  padding-bottom: 30px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    min-height: 500px;
    margin-bottom: 20px;
  }
  &-search {
    width: $max-width;
    margin: 0 auto;
    background: white;
    padding: 15px;
    margin-bottom: 15px;
    border-top: 1px solid #f3f3f3;
  }
  &-lists {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 8px));
    gap: 15px;
  }
}
</style>
